/**
 * 検索リクエスト
 * 
 */
export default class Request {
  /**
   * required: lat, lng,
   * optional: radius, types, places, latlng
   *
   * @param {object} opt
   * @returns {undefined}
   */
  constructor(opt) {
    opt = opt || {};

    if (opt.latlng){
      if (!opt.lat){
        opt.lat = opt.latlng.lat();
      }
      if (!opt.lng){
        opt.lng = opt.latlng.lng();
      }
    }

    this.opt = opt;    
  }

  toQueryString() {
    var params = {};
    var opt = this.opt;

    if (opt.lat) params.lat = opt.lat;
    if (opt.lng) params.lng = opt.lng;
    if (opt.radius) params.radius = opt.radius;
    if (opt.types) params.types = opt.types.join('-');
    if (opt.places) params.places = opt.places.join('-');

    return $.param(params);
  }
  isOrigined(key) {
    return this.opt.origin === key;
  }

  get(key) {
    return this.opt[key];
  }

  has(key) {
    return !!this.opt[key];
  }
  /**
   *
   * @param {type} params
   * @returns {Request}
   */
  extend(params) {
    var opt = $.extend(this.opt, params);
    return new Request(opt);
  }
}

Request.prototype.search_url = null;



// WEBPACK FOOTER //
// ./map/js/ih/Request.js